<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <h2 class="mt-lg-4" style="font-family: OpenSans-bold; margin-bottom: -10px;">
      <strong>{{TitleHeader}}</strong>
    </h2>
    <!--Section: Horizontal stepper-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Card image-->
        <div
          class="price white-text rounded-top"
          v-bind:style="{padding: '1rem 2rem', textAlign: 'left', background: '#026ab4', fontFamily: 'OpenSans-Regular', fontSize: '16px', lineHeight: '1.38'}"
        >
          <span>
            <img
              alt="icono boletín"
              src="https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Contratistas_Icon@3x.png"
              class="img-fluid"
              style="width: 28px; height: 26px"
            />
          </span>
          &nbsp; {{TitleHeader}}
          <div class="text-right" style=" margin-top: -10px; margin-right: -20px; float: right;">
            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
              <span slot="tip">Descartar registro</span>
              <mdb-btn
                slot="reference"
                outline="white"
                rounded
                size="sm"
                class="px-2 style_BTN"
                @click="remove()"
              >
                <mdb-icon icon="times" class="mt-0" />
              </mdb-btn>
            </mdb-tooltip>
          </div>
        </div>

        <!--/Card image-->

        <!--Card content-->
        <mdb-card-body>
          <form id="gateForm" class="needs-validation" novalidate @submit="submitForm">
            <mdb-row class="form-row">
              <!--Form content-->
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro">Datos del registro</p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="title"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Título</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="title"
                        required
                        maxlength="300"
                        minlength="3"
                        v-model="noticeTitle"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Asigna un Título</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="labelText"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Descripción</label>
                      <textarea
                        class="form-control"
                        id="labelText"
                        rows="4"
                        maxlength="1500"
                        required
                        v-model="noticeDesc"
                      ></textarea>
                      <span
                        style="color: #a09c9c; margin-top: 0rem;"
                        class="limiter"
                      >{{characterRemaining}}/1500</span>
                    </div>
                  </mdb-col>
                </mdb-row>

                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Tipo de noticia</label>
                      <model-select
                        :options="TypesList"
                        v-model="typesModel"
                        style="height: 37px;"
                        placeholder="Selecciona un tipo de noticia"
                        :isError="typeValid"
                      ></model-select>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="name"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Nombre de contacto</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="name"
                        maxlength="300"
                        minlength="3"
                        v-model="nameContact"
                        style="height: 37px; font-size: 12px; width: 100%;"
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="title"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Teléfono de contacto</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="title"
                        maxlength="300"
                        minlength="3"
                        v-model="phone"
                        style="height: 37px;  font-size: 12px; width: 100%;"
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="email"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Correo de contacto</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="email"
                        maxlength="300"
                        minlength="3"
                        v-model="emailContact"
                        style="height: 37px; font-size: 12px; width: 100%;"
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="time1"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Fecha y hora de inicio</label>
                      <date-picker id="time1" required v-model="dateStart" :config="options"></date-picker>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="time2"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Fecha y hora de término</label>
                      <date-picker
                        :disabled="isDisabled"
                        required
                        v-model="dateEnd"
                        :config="options2"
                      ></date-picker>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-col md="11">
                  <div class="form-group">
                    <mdb-row style="overflow: auto; padding-left: 10%;">
                      <div v-if="file_url==''">
                        <div>
                          <mdb-btn type="button" class="btn-Adjuntar btn-file">
                            <mdb-icon icon="paperclip" class="mt-0" />
                            <span style="font-size: 8px">Adjuntar imagen</span>
                            <input
                              type="file"
                              accept="image/jpeg, image/png"
                              name="file"
                              id="file"
                              @change="addPhoto"
                            />
                          </mdb-btn>
                        </div>
                      </div>
                      <div v-else>
                        <mdb-row>
                          <div>
                            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                              <span slot="tip">Eliminar archivo</span>
                              <mdb-btn
                                slot="reference"
                                type="button"
                                rounded
                                class="boton-eliminar"
                                @click="removeFile"
                              >
                                <mdb-icon icon="times" class="mt-0" />
                              </mdb-btn>
                            </mdb-tooltip>
                          </div>
                        </mdb-row>
                        <mdb-row>
                          <div class="embed-responsive" style="width: 22rem;">
                            <img
                              alt="imagen boletín"
                              :src="file_url"
                              style="display: inline-block; width: 100%"
                            />
                          </div>
                        </mdb-row>
                      </div>
                    </mdb-row>
                  </div>
                </mdb-col>
              </mdb-col>
            </mdb-row>
            <mdb-row class="justify-content-center">
              <mdb-col cols="auto" style="text-align: right;">
                <mdb-btn
                  @click="remove()"
                  color="color-prev"
                  type="button"
                  class="btn-prev Rectngulo-14"
                >Cancelar</mdb-btn>
              </mdb-col>
              <mdb-col cols="auto" class="ms-3">
                <mdb-btn
                  v-if="TitleHeader=='Nuevo boletín'"
                  type="submit"
                  class="btn btn-next btn-color-next Rectngulo-14"
                >Publicar</mdb-btn>
                <mdb-btn
                  v-else
                  type="submit"
                  class="btn btn-next btn-color-next Rectngulo-14"
                >Actualizar</mdb-btn>
              </mdb-col>
              <!--Buttons content-->
            </mdb-row>
          </form>
        </mdb-card-body>
        <!--/.Card content-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Horizontal stepper-->
    <!--Modal edit invited -->
  </mdb-container>
</template>
<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { ModelSelect } from "vue-search-select";
import "bootstrap/dist/css/bootstrap.css";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import {
  mdbContainer,
  mdbTooltip,
  mdbView,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbInput,
  mdbRow,
  mdbCol,
  mdbTextarea,
  mdbIcon,
  mdbBtn
} from "mdbvue";

export default {
  name: "createNew",
  components: {
    mdbTooltip,
    mdbContainer,
    mdbView,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbInput,
    mdbTextarea,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn,
    datePicker,
    ModelSelect
  },
  data() {
    return {
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      TitleHeader: "Nuevo boletín",
      noticeTitle: "",
      noticeDesc: "",
      allFrac: false,
      phone: null,
      urlContact: null,
      communityFile: "",
      extensionFile: "",
      communityType: "",
      files: null,
      file_url: "",
      TypesList: [
        {
          value: 5,
          text: "Restaurante"
        },
        {
          value: 1,
          text: "Deportes"
        },
        {
          value: 2,
          text: "Social"
        },
        {
          value: 3,
          text: "Eventos"
        }
      ],
      typesModel: {
        value: "",
        text: ""
      },
      typeValid: false,
      dateStart: null,
      dateEnd: null,
      dateMin:  false,
      options: {
        format: "YYYY-MM-DDTHH:mm:ss",
        useCurrent: true,
        useStrict: true,
        minDate: Date.now(),
        locale: "es",
        icons: {
          time: "far fa-clock",
          date: "far fa-calendar-alt",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      options2: {
        format: "YYYY-MM-DDTHH:mm:ss",
        useCurrent: false,
        useStrict: false,
        minDate: "1900-01-30",
        locale: "es",
        icons: {
          time: "far fa-clock",
          date: "far fa-calendar-alt",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      isDisabled: true
    };
  },
  methods: {
    getOneNewsLetter() {
      if (this.isEdit) {
        this.TitleHeader = "Editar boletín";
        this.$set(this.options, 'minDate', new Date(this.comunity.startDate))
        this.noticeTitle = this.comunity.title;
        this.noticeDesc = this.comunity.description;
        this.nameContact = this.comunity.contactName;
        this.phone = this.comunity.contactPhone;
        this.emailContact = this.comunity.contactEmail;
        this.urlContact = this.comunity.contactLink;
        this.dateStart = this.comunity.startDate;
        this.dateEnd = this.comunity.endDate;
        this.typesModel = { value: 1, text: this.comunity.type };
        if (this.comunity.fileId) {
          this.file_url = this.comunity.file.publicUrl;
        }
      }
    },
    remove() {
      var obj = [];
      this.$store.commit("cm/setComunity", obj);
      this.$store.commit("cm/setEdit", false);
      window.location.href = "/newsletters";
    },
    removeFile() {
      this.file = null;
      this.file_url = "";
      this.communityFile = "";
      this.extensionFile = "";
    },
    addPhoto: function(evt) {
      this.file_url = URL.createObjectURL(evt.target.files[0]);
      this.communityType = evt.target.files[0].type;
      this.extensionFile = evt.target.files[0].name.split(".")[1];
      var img = new Image();
      let aux = this;
      img.src = URL.createObjectURL(evt.target.files[0]);
      img.onload = function() {
        var rdr = new FileReader();
        rdr.onload = function(e) {
          aux.files = e.target.result.split(",")[1];
        };
        rdr.readAsDataURL(evt.target.files[0]);
      };
    },

    submitForm(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      if (this.typesModel.value == "") {
        this.typeValid = true;
      }

      if (
        this.noticeTitle &&
        this.noticeDesc &&
        this.dateStart &&
        this.dateEnd &&
        !this.typeValid
      ) {
        if (this.isEdit) {
          this.putNotices();
        } else {
          this.postNotices();
        }
      }
    },
    putNotices() {
      var uuid = this.uuidv4();
      var data = {
        title: this.noticeTitle,
        description: this.noticeDesc,
        contactName: this.nameContact,
        contactPhone: this.phone,
        contactEmail: this.emailContact,
        contactLink: this.urlContact,
        startDate: this.dateStart,
        endDate: this.dateEnd,
        type: this.typesModel.text
      };
      if (this.files) {
        var fileData = {
          uuid: uuid,
          name: uuid,
          extension: this.extensionFile,
          mimeType: this.communityType,
          content: this.files
        };

        data["file"] = fileData;
      }
      let aux = this;
      Axios.put(
        Servers.serverApi + "api/newsletters/" + aux.comunity.uuid,
        data,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {
          aux.showMessageSucces("Boletín actualizado");
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    postNotices() {
      var uuid = this.uuidv4();
      var data = {
        title: this.noticeTitle,
        description: this.noticeDesc,
        contactName: this.nameContact,
        contactPhone: this.phone,
        contactEmail: this.emailContact,
        contactLink: this.urlContact,
        startDate: this.dateStart,
        endDate: this.dateEnd,
        type: this.typesModel.text
      };
      if (this.files) {
        var fileData = {
          uuid: uuid,
          name: uuid,
          extension: this.extensionFile,
          mimeType: this.communityType,
          content: this.files
        };

        data["file"] = fileData;
      }
      let aux = this;
      Axios.post(Servers.serverApi + "api/newsletters", data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.showMessageSucces("Boletín creado");
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../../../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>Correcto</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
          this.remove();
        }
      });
    }
  },
  created() {
         this.getOneNewsLetter();
  },
  mounted() {
   
  },
  computed: {
    isEdit() {
      return this.$store.state.cm.edit;
    },
    comunity() {
      return this.$store.state.cm.comunityObject;
    },
    characterRemaining: function() {
      return this.noticeDesc.length;
    },
  },
  watch: {
    typesModel(newValue) {
      this.typesModel = newValue;
      if (newValue.value != "") {
        this.typeValid = false;
      } else {
        this.typeValid = true;
      }
    },
    dateStart(value) {
      this.dateStart = value;
      if (value) {
        this.isDisabled = false;
        this.$set(this.options2, "minDate", value);
      } else {
        this.isDisabled = true;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.btn_background {
  background-color: #ed5f5f !important;
  object-fit: contain;
  width: 31.2px;
}
</style>
<style scoped>
.btn-Adjuntar {
  width: 10rem !important;
  height: 5rem !important;
  border-radius: 6px !important;
  border: solid 1px #1a8a68 !important;              /* Verde más claro y fresco */
  background-color: #28a187 !important;              /* Fondo más amigable */
  color: rgb(255, 255, 255) !important;                           /* Para mejor contraste */
  transition: background-color 0.3s ease, filter 0.3s ease;
}

.btn-Adjuntar:hover,
.btn-Adjuntar:active,
.btn-Adjuntar.clicked {
  background-color: #218f77 !important;              /* Un tono más oscuro al hacer hover */
  filter: brightness(95%);
  color: white !important;
}

.btn-file {
  overflow: hidden;
  position: relative;
}
.btn-file input[type="file"] {
  cursor: inherit;
  display: block;
  font-size: 100px;
  min-height: 100%;
  min-width: 100%;
  opacity: 0;
  position: absolute;
  right: 0;
  text-align: right;
  top: 0;
}

.previewImg {
  position: initial;
  z-index: 0;
}

.boton-eliminar {
  position: absolute;
  top: 0rem;
  left: 0.7rem;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.8); /* fondo opcional para visibilidad */
  border-radius: 50%;
  padding-top: 5px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
